import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import BiometricAttendanceService from '../../services/BiometricAttendanceService';

const initialState = {
    fieldconfigData: {},
    biometricDetail: {},
    columnConfig: [],
    status: 'idle'
};

export const fetchBiometricConfig = createAsyncThunk("biometricFieldConfig", async () => {
    const response = await BiometricAttendanceService.getFormFieldConfig();
    return response;
});

export const fetchBiometricDetails = createAsyncThunk("biometricDetail", async () => {
    const response = await BiometricAttendanceService.getBiometricDetails();
    return response;
})


export const BiometricSlice = createSlice({
    name : 'biometricAttendance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                fetchBiometricConfig.pending, (state) => {
                   state.status = "loading"; 
                }
            )
            .addCase(
                fetchBiometricConfig.fulfilled, (state, action) => {
                    state.status = "idle";
                    state.fieldconfigData = action.payload;
                }
            ).addCase(
                fetchBiometricDetails.pending, (state) => {
                   state.status = "loading"; 
                }
            )
            .addCase(
                fetchBiometricDetails.fulfilled, (state, action) => {
                    state.status = "idle";
                    state.biometricDetail = action.payload;
                }
            )
    }
});

export const selectBiometricFormField = (state) => {
    return state?.biometricAttendance?.fieldconfigData;
}

export const BiometricDetailsSelector = (state) => {
    return state?.biometricAttendance?.biometricDetail
}

export default BiometricSlice.reducer;